import React from 'react';
import infoGraphic from './assets/nei_grid_2x.png';
import {Helmet} from 'react-helmet';
import './leakRecognitionPage.scss';

/**
 * The LeakRecognitionPage component.
 *
 * @constructor
 */
export class LeakRecognitionPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="leak-recognition-page" className="system-page">
        <Helmet>
          <title>Utility Leak Recognition - NEI</title>
          <meta name = "description" content ="A pipeline release can pose dangerous hazards to the health and safety of those around the leak, and can also cause environmental damage." />
        </Helmet>
        <div className="container">
          <div className="row">
            <div className="col">
              <p>A pipeline release can pose dangerous hazards to the health and safety of those around the leak, and can also cause environmental damage. It is important to recognize the signs of a potential pipeline leak and know how to react.</p>
              <h1>Not all signs must be present to indicate a leak!</h1>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <div className="text-center">
                <img src={infoGraphic} alt="Infographic" />
              </div>
            </div>
          </div>

        </div>
        <div className="container">
          <div className="row">
            <div className="col leak-recognition-content">
              <h1>
                Are you aware of ...
              </h1>
              <h2>
                ... Hazards of Natural Gas?
              </h2>
              <p>
                Natural gas is flammable and is easily ignited by heat, sparks or
                flames. Natural gas may also form an explosive mixture with the air
                and, if it reaches an ignition source, “flashback” – meaning travel
                back to the source of the natural gas.
              </p>
              <p>
                Vapors may cause dizziness or asphyxiation without warning and may
                be toxic if inhaled at high concentrations. Contact with natural gas
                or liquefied natural gas may cause burns, severe injury and/or
                frostbite.
              </p>
              <h2>
                ...Hazards of Crude Oil and Refined Products?
              </h2>
              <p>
                Contact with crude oil may burn skin and eyes. Fire may produce
                corrosive and/or toxic gases. Inhalation may cause skin and eye
                irritation, dizziness or suffocation. A release of crude may also
                cause pollution.
              </p>
              <h2>
                ...Hazards of HVLs?
              </h2>
              <p>
                Easily ignited by high heat, sparks or flames, and will form
                explosive mixtures with air. Vapors may cause dizziness or
                asphyxiation without warning and may be toxic if inhaled at high
                concentrations. Contact with gas or liquefied gas may cause burns,
                severe injury and/or frostbite. Fire may produce irritating and/or
                toxic gases.
              </p>
              <h2>
                ...Hazards of Carbon Dioxide?
              </h2>
              <p>
                Carbon dioxide will not burn, but may explode if heated. If it
                accumulates in low-lying areas or inside a confined space it may
                result in asphyxiation, causing suffocation. Exposure can also
                result in frostbite.
              </p>
              <h2>
                ...Hazards of Anhydrous Ammonia?
              </h2>
              <p>
                Ammonia is a toxic gas or liquid that, when concentrated, is
                corrosive to tissues upon contact including burning of the eyes,
                inflammation of the skin, vomiting, abdominal and chest pains, and
                breathing issues and wheezing. Persons with prolonged exposure to
                ammonia will lose their ability to detect the odor and exposure to
                ammonia in sufficient quantities can be fatal.
              </p>
              <h2>
                ...Hazards of Hydrogen Gas?
              </h2>
              <p>
                Hydrogen is nontoxic; however, it could displace air in a poorly
                ventilated or confined space, resulting in asphyxiation. Hydrogen
                gas is also highly flammable and can explode causing burns. When
                working with liquid hydrogen, there is an additional potential
                health hazard of cryogenic burns.
              </p>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

LeakRecognitionPage.propTypes = {};

export default LeakRecognitionPage;



// WEBPACK FOOTER //
// ./src/components/pages/leakRecognition/LeakRecognitionPage.js